import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, type ShiftTask, TaskCategory } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { promisifyApi } from "@/utility/utils";

interface UseGetShiftTasksOptions {
    category?: TaskCategory;
    enabled?: boolean;
}

export const useGetShiftTasks = (options: UseGetShiftTasksOptions = {}) => {
    const { category, enabled } = options;
    const { current: session } = useContext(SessionContext);
    const listTasksApi = promisifyApi(api.hooks.shift.listTasks());

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useQuery<ShiftTask[] | null, Error>({
        queryKey: ["shiftTasks", userUuid, tenantId, category],
        queryFn: async () => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            return await listTasksApi.send(session.context, { category });
        },
        enabled: !!userUuid && !!tenantId && !!session?.context && (enabled !== false),
        staleTime: 5 * 60 * 1000,
        gcTime: 5 * 60 * 1000,
    });
};
